import React from 'react';

const PASSOS = [
  { titulo: 'Crie sua conta', texto: 'Grátis, com CPF ou CNPJ.' },
  { titulo: 'Calcule e emita', texto: 'Compare PAC e SEDEX e gere a etiqueta na hora.' },
  { titulo: 'Poste e acompanhe', texto: 'Leve aos Correios e veja o rastreio aqui.' },
];

const HowItWorks = () => (
  <section id="como-funciona" className="bg-white py-[70px] lg:py-[110px] scroll-mt-20">
    <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
      <h2 className="text-center text-[30px] lg:text-[44px] font-black tracking-tight leading-tight text-slate-900">Simples assim: <span className="inn-text-gradient">3 passos</span></h2>
      <div className="relative grid md:grid-cols-3 gap-8 md:gap-10 mt-12 lg:mt-16">
        <div className="hidden md:block absolute top-[34px] left-[16%] right-[16%] border-t-2 border-dashed border-slate-300" />
        {PASSOS.map((p, i) => (
          <div key={p.titulo} className="relative text-center">
            <div className={`w-[68px] h-[68px] rounded-full mx-auto mb-4 flex items-center justify-center text-[26px] font-black text-white ${i === 1 ? 'bg-gradient-to-br from-[#F98B3D] to-[#F77820] shadow-[0_12px_26px_rgba(247,120,32,0.3)]' : 'bg-gradient-to-br from-[#2A5BC7] to-[#1E429F] shadow-[0_12px_26px_rgba(42,91,199,0.3)]'}`}>{i + 1}</div>
            <h3 className="text-[21px] font-black text-slate-900 mb-1.5">{p.titulo}</h3>
            <p className="text-slate-500 text-base leading-relaxed max-w-[270px] mx-auto">{p.texto}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
